import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {LocalCustomerModel} from '../../../../models/LocalCustomerModel';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';
import {FormControl} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {ProviderModel} from '../../../../models/ProviderModel';
import {AllSettingsFilterModel} from '../../../../models/AllSettingsFilterModel';
import {RegionModel} from '../../../../models/RegionModel';
import {ContractTypeModel} from '../../../../models/ContractTypeModel';
import {ResourcesUnitModel} from '../../../../models/ResourcesUnitModel';
import {DesignServicesModel} from '../../../../models/DesignServicesModel';
import {CurrencyModel} from '../../../../models/CurrencyModel';
import {SizeModel} from '../../../../models/SizeModel';
import {SiteModel} from '../../../../models/SiteModel';
import {LocalCustomerAnagrafService} from '../../../general-services/service-local-customer-anagraf/local-customer-anagraf.service';

@Component({
  selector: 'app-local-customer-filter',
  templateUrl: './local-customer-filter.component.html',
  styleUrls: ['./local-customer-filter.component.scss']
})
export class LocalCustomerFilterComponent extends FilterAbstractModel implements OnInit, OnChanges, OnDestroy {

  localCustomerListFilter: any[];
  optionSelected: any;
  formControl: FormControl = new FormControl();
  filteredOptions: BehaviorSubject<ProviderModel[]> = new BehaviorSubject<ProviderModel[]>([]);

  filterAllSettings: AllSettingsFilterModel;

  @Input() localCustomerData: any;
  @Input() localCustomerSelected: LocalCustomerModel;

  @Input() inAllSettings?: boolean;
  @Input() regionForFilterInSettings?: RegionModel;
  @Input() providerForFilterInSettings?: ProviderModel;
  @Input() contractTypeForFilterInSettings?: ContractTypeModel;
  @Input() resourceUnitForFilterInSettings?: ResourcesUnitModel;
  @Input() designServicesForFilterInSettings?: DesignServicesModel;
  @Input() currencyForFilterInSettings?: CurrencyModel;
  @Input() sizeForFilterInSettings?: SizeModel;
  @Input() siteForFilterInSettings?: SiteModel;

  @Input() numAnnoMeseFromForFilterInSettings: number;
  @Input() numAnnoMeseToForFilterInSettings: number;

  constructor(private localCustomerAnagrafService: LocalCustomerAnagrafService) {
    super();
  }

  ngOnInit() {
    this.fetchFilterData();
    this.formControl.setValue(this.localCustomerSelected ? this.localCustomerSelected.cod : null);
    this.formControl.valueChanges
      .subscribe(value => {
        const result = this._filter(value);
        this.filteredOptions.next(result);
        this.dataFiltered.emit(this.filteredOptions.value.find(x => x.cod === value || x.description === value));
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('localCustomerData' in changes) {
      this.localCustomerListFilter = this.localCustomerData;
      this.optionSelected = null;
    }
    if (
      'regionForFilterInSettings' in changes ||
      'providerForFilterInSettings' in changes ||
      'contractTypeForFilterInSettings' in changes ||
      'resourceUnitForFilterInSettings' in changes ||
      'sizeForFilterInSettings' in changes ||
      'siteForFilterInSettings' in changes
    ) {
      this.fetchFilterData();
    }
    if (this.localCustomerSelected) {
      this.optionSelected = this.localCustomerSelected ? this.localCustomerSelected.cod : null;
    }
    this.filteredOptions.next(this._filter(this.optionSelected ? this.optionSelected.cod : ''));
  }

  fetchFilterData() {
    if (this.inAllSettings) {
      this.filterAllSettings = new AllSettingsFilterModel(
        this.regionForFilterInSettings,
        this.localCustomerSelected,
        this.resourceUnitForFilterInSettings,
        this.providerForFilterInSettings,
        this.contractTypeForFilterInSettings,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        this.sizeForFilterInSettings?.cod ? this.sizeForFilterInSettings : null,
        this.siteForFilterInSettings,
        null,
        null,
        null,
        null
      );
      this.localCustomerAnagrafService.getListInAllSettings(
        this.localCustomerAnagrafService.baseUrl,
        this.filterAllSettings)
        .subscribe(
          (result: any) => {
            this.localCustomerListFilter = this.localCustomerData = result;
            // this.optionSelected = null;
            this.filteredOptions.next(this._filter(this.optionSelected ? this.optionSelected.cod : ''));
          });
    }
  }

  private _filter(value: string): ProviderModel[] {
    const filterValue = value ? value.toLowerCase() : '';
    if (!this.localCustomerData) {
      return [];
    }
    return this.localCustomerData.filter(
      option => option.cod.toLowerCase().includes(filterValue) || option.description.toLowerCase().includes(filterValue)
    );
  }

  ngOnDestroy(): void {

  }

}
